import { render, staticRenderFns } from "./subprogram-nba-player-card.vue?vue&type=template&id=a29f5656&scoped=true&"
import script from "./subprogram-nba-player-card.vue?vue&type=script&lang=js&"
export * from "./subprogram-nba-player-card.vue?vue&type=script&lang=js&"
import style0 from "./subprogram-nba-player-card.vue?vue&type=style&index=0&id=a29f5656&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a29f5656",
  null
  
)

export default component.exports